<template>
    <!-- hide btn defualt  -->
    <modal
        :id="modalId"
        size="large"
        v-model="showModal"
        :title="$t('view_team_culture')"
        :preloader="preloader"
        :loading="preloader"
        :hide-footer="true"
    >
        <div class="p-3">
            <div class="mb-4">
                <h5 class="font-weight-bold">{{ formData.title }}</h5>
                <span class="badge" :class="formData.is_active ? 'badge-success' : 'badge-danger'">
                    {{ formData.is_active ? $t('active') : $t('inactive') }}
                </span>
            </div>

            <div v-for="(section, index) in formData.dynamic_sections" :key="index" class="border p-3 rounded mb-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="badge badge-primary text-uppercase">{{ section.type }}</span>
                    <div v-if="section.settings && section.settings.show_by_time">
                        <small class="text-muted">
                            <i class="far fa-clock"></i> {{ section.settings.start_time }} - {{ section.settings.end_time }}
                        </small>
                    </div>
                </div>

                <div v-if="section.type === 'banner'" class="bg-light p-3 rounded text-center">
                    <h4>{{ section.content.greeting }}</h4>
                    <p class="mb-0 text-muted">{{ section.content.subtext }}</p>
                </div>

                <div v-if="section.type === 'schedule'">
                    <ul class="list-group">
                        <li v-for="(item, i_index) in section.content.items" :key="i_index" class="list-group-item d-flex justify-content-between align-items-center">
                            <span>{{ item.label }}</span>
                            <span class="badge badge-secondary badge-pill">{{ item.time }}</span>
                        </li>
                    </ul>
                </div>

                <div v-if="section.type === 'values'">
                    <h6 class="mb-3">{{ section.content.title }}</h6>
                    <div class="row">
                        <div v-for="(item, v_index) in section.content.items" :key="v_index" class="col-md-6 mb-3">
                            <div class="card h-100 shadow-sm">
                                <div class="card-body">
                                    <h6 class="card-title font-weight-bold">{{ item.title }}</h6>
                                    <p class="card-text text-muted small">{{ item.description }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
             <div v-if="!formData.dynamic_sections || formData.dynamic_sections.length === 0" class="text-center text-muted mt-5 mb-5">
                <p>{{ $t('no_content_available') }}</p>
            </div>
            <!-- footer -->
            <div class="text-right">
                <button class="btn btn-secondary" @click="closeModal">{{ $t('close') }}</button>
            </div>
        </div>
    </modal>
</template>

<script>
import { axiosGet } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: 'TeamCultureViewModal',
    props: {
        selectedUrl: String,
    },
    data() {
        return {
            modalId: 'team-culture-view-modal',
            showModal: false,
            formData: {
                title: '',
                is_active: false,
                dynamic_sections: [],
            },
            preloader: false,
        };
    },
    created() {
        if (this.selectedUrl) {
            this.preloader = true;
            this.fetchCultureData();
        }
    },
    watch: {
        showModal(value) {
            if (!value) {
                this.$emit('close');
            }
        }
    },
    mounted() {
        this.showModal = true;
    },
    methods: {
        fetchCultureData() {
            axiosGet(this.selectedUrl).then(response => {
                const data = response.data;
                this.formData = data;
                this.preloader = false;
            }).catch(({response}) => {
                if (response && response.data && response.data.message) {
                    this.$toastr.e(response.data.message);
                } else {
                    this.$toastr.e('Error fetching data');
                }
                this.preloader = false;
            });
        },
        closeModal() {
            this.showModal = false;
            $('#team-culture-view-modal').modal('hide');
        }
    },
};
</script>
